export const PARTNER_CHANNELS = ["MWM", "LAUNCHIT_HEALTH"] as const;
export type PartnerChannel = (typeof PARTNER_CHANNELS)[number];
export const DEFAULT_PARTNER_CHANNEL: PartnerChannel = "MWM";

export function resolvePartnerChannel(search: string): PartnerChannel {
  const channel = new URLSearchParams(search).get("channel");
  return (PARTNER_CHANNELS as readonly string[]).includes(channel ?? "")
    ? (channel as PartnerChannel)
    : DEFAULT_PARTNER_CHANNEL;
}
